<template>
    <!-- maincss Login Modal -->
    <div
        class="modal login-form-popup fade h-auto register-modal-popup"
        id="login"
        tabindex="-1"
        aria-labelledby="login"
        aria-hidden="true"
        data-keyboard="false"
        data-backdrop="static"
    >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-body">
                    <a
                        href="#"
                        class="popup-close"
                        id="popup-close"
                        data-dismiss="modal"
                    >
                        <img src="/maincss/images/cancel.svg" alt=" " />
                    </a>
                    <div class="login-form">
                        <h3>Login</h3>
                        <p>In Order to save designs you need to login</p>
                        <form
                            method="post"
                            @submit.prevent="onSubmitToLogin"
                            data-vv-scope="loginform"
                            :key="'loginform'"
                        >
                            <div class="form-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="Email"
                                    name="email"
                                    v-model="login_data.email"
                                    v-validate="'required|email'"
                                />
                                <label>Email ID</label>
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <small
                                    class="form-text text-error text-left"
                                    v-show="errors.has('loginform.email')"
                                >
                                    {{ errors.first("loginform.email") }}
                                </small>
                            </div>
                            <div class="form-group">
                                <input
                                    type="password"
                                    class="form-control"
                                    id="Password"
                                    name="password"
                                    v-model="login_data.password"
                                    v-validate="'required'"
                                />
                                <label>Password</label>
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <small
                                    class="form-text text-error text-left"
                                    v-show="errors.has('loginform.password')"
                                >
                                    {{ errors.first("loginform.password") }}
                                </small>
                            </div>
                            <button
                                type="submit"
                                class="btn btn_orange bg_primary_orange text_white w-100 mt_34 mb_32 btn_h60"
                            >
                                LOGIN
                            </button>
                            <div class="d-md-flex">
                                <div>
                                    <a
                                        href="#"
                                        class="btn-link"
                                        data-toggle="modal"
                                        data-target="#forgotpassword"
                                        data-dismiss="modal"
                                        >Forgot Password?</a
                                    >
                                </div>

                                <p class="small ml-auto">
                                    Don’t have an account?
                                    <a
                                        href="#"
                                        class="btn-link register-now"
                                        data-toggle="modal"
                                        data-target="#register"
                                        data-dismiss="modal"
                                        >Register here</a
                                    >
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { LOGIN, REGISTER, LOGOUT } from "@/store/actions.type";
import ApiService from "@/common/api.service";

export default {
    data() {
        return {
            login_data: [
                {
                    email: null,
                    password: null
                }
            ],
            registration_data: [
                {
                    first_name: null,
                    last_name: null,
                    email: null,
                    password: null,
                    confirm_password: null,
                    accept_terms: null
                }
            ],
            resetform_data: [
                {
                    email: null
                }
            ],
            redirect_path: "/myorder"
        };
    },
    mounted() {
        var _this = this;
        /* eslint-disable */
        $(document).on("hide.bs.modal", "#login", function () {
            _this.$validator.reset();
            _this.login_data = [
                {
                    email: null,
                    password: null
                }
            ];
            //Do stuff here
        });
        $(document).on("click", ".login-cart", function () {
            _this.redirect_path = $(this).data("path");
        });
        /* eslint-enable */
    },
    methods: {
        logout() {
            this.$store.dispatch(LOGOUT).then(() => {
                this.$router.push({ path: "/" });
            });
        },
        onSubmitToLogin() {
            var _this = this;
            // console.log(this.login_data,_this.$validator.validateAll("loginform"));

            _this.$validator.validateAll("loginform").then((isValid) => {
                if (isValid) {
                    _this.$store
                        .dispatch(LOGIN, {
                            email: _this.login_data.email,
                            password: _this.login_data.password
                        })
                        .then((response) => {
                            if (response.success) {
                                _this.$toast.success("Login Successfully.", {
                                    position: "top-right"
                                });
                                document.getElementById("popup-close").click();
                                ApiService.setHeader();
                                _this.$bus.emit("update-cart");
                                _this.syncCart();

                                _this.$router.push({ path: "/" });
                            } else if (
                                response.error &&
                                response.error ==
                                    "Your account is not active. Please verify your email."
                            ) {
                                document.getElementById("popup-close").click();
                                _this.$toast.error(
                                    "Please verify your email, a mail has been sent to your email.",
                                    {
                                        position: "top-right"
                                    }
                                );
                            } else {
                                let field =
                                    response.error == "Invalid password"
                                        ? "password"
                                        : "email";
                                _this.errors.itemslength = 0;
                                _this.errors.items.push({
                                    id: 1,
                                    vmId: _this.errors.vmId,
                                    field: field,
                                    msg: response.error,
                                    scope: "loginform"
                                });
                                _this.$toast.error(
                                    response.error ||
                                        "Invalid email or password.",
                                    {
                                        position: "top-right"
                                    }
                                );
                            }
                        })
                        .catch((_response) => {});
                } else {
                    /* noop */
                }
            });
        },
        syncCart() {
            if (localStorage.getItem("cart")) {
                let cart = JSON.parse(localStorage.getItem("cart"));
                new Promise(() => {
                    let post_data = {
                        items: cart.items,
                        totalQty: cart.totalQty,
                        totalPrice: cart.totalPrice
                    };
                    ApiService.setHeader();
                    // console.log(cart.items,post_data);
                    ApiService.post("/sync-cart", post_data)
                        .then(({ _data }) => {})
                        .catch(({ _response }) => {});
                });
            }
        },
        onSubmitToRegister() {
            this.$validator.validateAll("signupform").then((isValid) => {
                if (isValid) {
                    this.$store
                        .dispatch(REGISTER, {
                            first_name: this.registration_data.first_name,
                            last_name: this.registration_data.last_name,
                            email: this.registration_data.email,
                            password: this.registration_data.password,
                            confirm_password:
                                this.registration_data.confirm_password
                        })
                        .then((_response) => {
                            /* eslint-disable */
                            _this.$toast.success(
                                "User registered Successfully.",
                                {
                                    position: "top-right"
                                }
                            );
                            $("#register").modal("hide");
                            /* eslint-enable */
                            this.$router.push({ path: "/" });
                        });
                } else {
                    /* noop */
                }
            });
        },
        onSubmitToResetPassword() {
            this.$validator.validateAll("signupform").then((isValid) => {
                if (isValid) {
                    this.$store
                        .dispatch(REGISTER, {
                            email: this.registration_data.email
                        })
                        .then((_response) => {
                            /* eslint-disable */
                            $("#register").modal("hide");
                            /* eslint-enable */
                            this.$router.push({ path: "/" });
                        });
                } else {
                    /* noop */
                }
            });
        }
    }
};
</script>
